
































































































































































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { QDialog, QPopupProxy } from "quasar";

import { Answer, Question, QuestionType } from "@/interfaces";
import { SurveyModule } from "@/store";
import SelectUniqueInsertDialog from "@/components/SelectUniqueInsertDialog.vue";

interface AnswerFormatted {
  title: string;
  id: string;
  type: string;
  answer: any;
  required: boolean;
  allowInsert: boolean;
  confType: string;
  options: any;
  placeholder: string;
  parentBind: string | string[];
}

@Component
export default class NewSurveyRepeaterDialog extends Vue {
  @Ref("new-survey-repeater-dialog")
  dialog!: QDialog;

  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: Array, required: true })
  fields!: Question[];

  @Prop({ type: Array, required: true })
  questions!: Question[];

  @Prop({ type: Object, required: true })
  repeaterQuestion!: Question;

  @SurveyModule.bindings.State
  answers!: Answer[];

  test = null;

  filteredOptions: Array<{
    id: string;
    options: any;
  }> = [];

  repeaterAnswers: AnswerFormatted[] = [];

  filteredRepeaterAnswers: AnswerFormatted[] = [];

  newValueArrays: any = [];

  mounted() {
    this.createdAnswers();
  }

  onDateFocus(answer: AnswerFormatted) {
    if (answer.confType === "date") {
      const dateRef = answer.id + "qDateProxy";
      const popupRef = this.$refs[dateRef] as QPopupProxy;
      console.log(popupRef);

      if (!Array.isArray(popupRef)) {
        popupRef.show();
      } else if (popupRef.length > 0) {
        popupRef[0].show();
      }
    }
  }

  createdAnswers(resetAnswer = true, bindParentId = "") {
    let answerValues: Array<{ [key: string]: any }> = [];
    const repeaterQuestionAnswer = this.answers.find(answer => answer.id === this.repeaterQuestion.id);

    if (repeaterQuestionAnswer) {
      answerValues = repeaterQuestionAnswer.answer;
    }

    this.repeaterAnswers = this.fields.map(field => {
      let options: any = [];
      let answerValue: any = [];

      answerValues.forEach(ans => {
        if (Array.isArray(ans[field.id])) {
          answerValue = [...answerValue, ...ans[field.id]];
        } else {
          answerValue = [...answerValue, ans[field.id]];
        }
      });

      if (field.type === QuestionType.SELECT || field.type === QuestionType.MULTI_SELECT) {
        options = [field.options];

        if (field.conf && field.conf.bind && field.conf.bind.length > 0) {
          const bindIds = Array.isArray(field.conf.bind) ? field.conf.bind : [field.conf.bind];
          let modelsUnique: string[] = [];
          let baseBindModels = [...this.answers.filter(answer => bindIds.includes(answer.id) && answer.answer)];

          if (baseBindModels.length === 0) {
            baseBindModels = [
              ...this.filteredRepeaterAnswers.filter(answer => bindIds.includes(answer.id) && answer.answer),
            ];
          }

          const bindModels = baseBindModels.map(model => {
            const parent = this.questions.find(question => question.id === model.id);

            if (parent) {
              if (
                parent.options &&
                parent.options.length > 0 &&
                Array.isArray(parent.options) &&
                typeof parent.options[0] === "object"
              ) {
                const options = model.answer.map((ans: any) => {
                  if (Array.isArray(parent.options)) {
                    const findOption: any = parent.options.find((opt: any) => opt.id === ans);

                    if (findOption) {
                      const opt = {
                        label: findOption.name,
                        value: findOption.id,
                      };
                      return opt;
                    }
                  }

                  if (typeof ans === "string" && ans.startsWith("_")) {
                    return {
                      label: ans.split("_")[1],
                      value: ans,
                    };
                  }

                  return ans;
                });

                return options;
              }
            }
            return model.answer;
          });

          if (bindModels.length > 0) {
            bindModels.forEach((bind: string) => {
              modelsUnique = [...modelsUnique, bind];
            });
            modelsUnique = [...new Set(modelsUnique)];

            if (field.options) {
              options = [];
              modelsUnique.forEach((model: string) => {
                const opts = field.options as { [key: string]: any };
                if (opts[model] && opts[model].length > 0) {
                  if (typeof opts[model][0] === "object") {
                    options = [
                      ...options,
                      ...opts[model].map((opt: any) => ({
                        label: opt.name,
                        value: opt.id,
                      })),
                    ];
                  } else {
                    options = [...options, ...opts[model]];
                  }
                }
              });
            } else if (Array.isArray(modelsUnique) && modelsUnique.length > 0 && Array.isArray(modelsUnique[0])) {
              options = [];
              modelsUnique.forEach(model => {
                options = [...options, ...model];
              });
            } else {
              options = [...modelsUnique];
            }
          } else {
            options = [];
          }
        } else if (Array.isArray(field.options)) {
          options = [...field.options];
          const filteredNewValues = [
            ...answerValue.filter((ans: any) => typeof ans === "string" && ans.startsWith("_")),
          ];

          filteredNewValues.forEach(newVal => {
            options.push({
              id: newVal,
              name: newVal.split("_")[1],
            });
          });

          if (field.options.length > 0 && typeof field.options[0] === "string") {
            const filteredNewValuesString = [...new Set(answerValue)];

            filteredNewValuesString.forEach((newVal: any) => {
              if (field.options && Array.isArray(field.options) && !field.options.includes(newVal)) {
                options.push(newVal);
              }
            });
          }
        }

        this.newValueArrays.push({
          id: field.id,
          newValues: [],
        });
      }

      let mappedOptions = [];

      if (options.length > 0 && typeof options[0] === "object") {
        mappedOptions = options.map((option: any) => {
          if (option.label) {
            return {
              label: option.label,
              value: option.value,
              disable: answerValue.includes(option.value),
            };
          } else {
            return {
              label: option.name,
              value: option.id,
              disable: answerValue.includes(option.id),
            };
          }
        });
      } else {
        mappedOptions = options.map((option: any) => ({
          label: option,
          value: option,
          disable: answerValue.includes(option),
        }));
      }

      const rules = [];

      if (field.type === QuestionType.TEXT) {
        if (field.conf) {
          if (field.conf.min) {
            const min = field.conf.min;
            rules.push(
              (val: any) => (val !== null && val.length >= min) || `E' necessario inserire almeno ${min} caratteri`,
            );
          }
          if (field.conf.max) {
            const max = field.conf.max;
            rules.push(
              (val: any) => (val !== null && val.length <= max) || `Non è possibile inserire più di ${max} caratteri`,
            );
          }
        }
      } else if (field.type === QuestionType.TEXT_NUMBER) {
        if (field.conf) {
          if (field.conf.min !== undefined) {
            const min = field.conf.min;
            rules.push((val: any) => {
              const value = parseInt(val);
              return value >= min || `Inserire un valore maggiore di ${min}`;
            });
          }
          if (field.conf.max !== undefined) {
            const max = field.conf.max;
            rules.push((val: any) => {
              const value = parseInt(val);
              return value <= max || `Inserire un valore minore di ${max}`;
            });
          }
        }
      } else {
        if (field.conf) {
          if (field.conf.min) {
            const min = field.conf.min;
            rules.push(
              (val: any) => (val !== null && val.length >= min) || `E' necessario selezionare almeno ${min} opzioni`,
            );
          }
          if (field.conf.max) {
            const max = field.conf.max;
            rules.push(
              (val: any) => (val !== null && val.length <= max) || `Non è possibile inserire più di ${max} opzioni`,
            );
          }
        }
      }

      this.filteredOptions.push({
        id: field.id,
        options: field.conf !== undefined && field.conf.unique === true ? mappedOptions : options,
      });

      if (field.conf !== undefined && !field.conf.unique) {
        mappedOptions = mappedOptions.map((option: any) => ({
          ...option,
          disable: false,
        }));
      }

      let answer: any = field.type === QuestionType.MULTI_SELECT || field.type === QuestionType.CHECKBOX ? [] : "";
      if (field.type === QuestionType.SELECT) {
        answer = null;
      }

      if (!resetAnswer) {
        const currentAns = this.filteredRepeaterAnswers.find(el => el.id === field.id);
        if (currentAns) {
          answer = currentAns.answer;
        }

        if (field.conf && field.conf.bind && field.conf.bind.includes(bindParentId)) {
          const parentAns = this.filteredRepeaterAnswers.find(el => el.id === bindParentId);

          if (parentAns && currentAns) {
            answer = field.type === QuestionType.MULTI_SELECT || field.type === QuestionType.CHECKBOX ? [] : "";

            if (field.type === QuestionType.SELECT) {
              answer = null;
            }
          }
        }
      }

      return {
        title: field.title,
        id: field.id,
        type: field.type,
        answer,
        confType: field.conf && field.conf.type ? field.conf.type : "text",
        parentBind: field.conf && field.conf.bind ? field.conf.bind : "",
        allowInsert: field.conf !== undefined && field.conf.allow_insert === true,
        required: field.conf !== undefined && field.conf.required === true,
        options: mappedOptions,
        placeholder: field.conf !== undefined && field.conf.placeholder ? field.conf.placeholder : "",
        rules,
      };
    });

    this.filteredRepeaterAnswers = [...this.repeaterAnswers];
  }

  onSubmit() {
    const newElement: { [Key: string]: any } = {};

    this.filteredRepeaterAnswers.forEach(answer => {
      newElement[answer.id] = answer.answer;
    });

    this.$emit("ok", newElement);
    this.hide();
  }

  onChange(index: number) {
    const bindParentId = this.filteredRepeaterAnswers[index].id;
    this.createdAnswers(false, bindParentId);
  }

  newValueAddedModal(questionId: string) {
    this.$q
      .dialog({
        component: SelectUniqueInsertDialog,
      })
      .onOk((newAllowInsertValue: string) => {
        let finalValue = newAllowInsertValue;
        const question = this.fields.find(q => q.id === questionId);

        if (question && question.conf && question.conf.allow_insert) {
          if (
            (question.options &&
              question.options.length > 0 &&
              Array.isArray(question.options) &&
              typeof question.options[0] === "object") ||
            (question.conf && question.conf.insert_type === "object")
          ) {
            const findArrNewValueIndex = this.newValueArrays.findIndex((filarr: any) => filarr.id === question.id);

            if (findArrNewValueIndex !== -1) {
              const find = this.newValueArrays[findArrNewValueIndex].newValues.find(
                (newValue: any) => newValue.value === `_${newAllowInsertValue}`,
              );

              if (!find) {
                this.$set(this.newValueArrays, findArrNewValueIndex, {
                  id: this.newValueArrays[findArrNewValueIndex].id,
                  newValues: [
                    ...this.newValueArrays[findArrNewValueIndex].newValues,
                    {
                      label: newAllowInsertValue,
                      value: `_${newAllowInsertValue}`,
                    },
                  ],
                });
              }

              finalValue = `_${newAllowInsertValue}`;
            }
          } else {
            finalValue = newAllowInsertValue;
          }
        }

        if (this.$refs[questionId]) {
          const componentsArray = this.$refs[questionId] as Vue[];
          const questionSelect: any = componentsArray[0];
          questionSelect.add(finalValue, true);
          questionSelect.options.push(finalValue);
          questionSelect.refresh();
        }
      });
  }

  newValueAdded(index: number, val: string, done: (val: any, type: string) => void) {
    const question = this.fields[index];

    if (question.conf && question.conf.allow_insert) {
      if (
        (question.options &&
          question.options.length > 0 &&
          Array.isArray(question.options) &&
          typeof question.options[0] === "object") ||
        (question.conf && question.conf.insert_type === "object")
      ) {
        const findArrNewValueIndex = this.newValueArrays.findIndex((filarr: any) => filarr.id === question.id);

        if (findArrNewValueIndex !== -1) {
          const find = this.newValueArrays[findArrNewValueIndex].newValues.find(
            (newValue: any) => newValue.value === `_${val}`,
          );

          if (!find) {
            this.$set(this.newValueArrays, findArrNewValueIndex, {
              id: this.newValueArrays[findArrNewValueIndex].id,
              newValues: [
                ...this.newValueArrays[findArrNewValueIndex].newValues,
                {
                  label: val,
                  value: `_${val}`,
                },
              ],
            });
          }

          done(`_${val}`, "add-unique");
        }
      } else {
        done(val, "add-unique");
      }
    }
  }

  filterFn(index: number, val: string, update: (fun: () => void) => void) {
    update(() => {
      const needle = val.toLowerCase();
      const answer = Object.assign({}, this.repeaterAnswers[index]);

      let options;
      if (answer.options && answer.options.length > 0 && typeof answer.options[0] === "object") {
        options = [...answer.options];
        if (val !== "") {
          options = options.filter(v => v.label.toLowerCase().indexOf(needle) > -1);
        }
      } else {
        options = [...(answer.options as string[])];
        if (val !== "") {
          options = options.filter(v => v.toLowerCase().indexOf(needle) > -1);
        }
      }

      const question = Object.assign({}, this.filteredRepeaterAnswers[index]);

      const optionsIndex = this.filteredOptions.findIndex(el => el.id === question.id);

      this.$set(this.filteredOptions, optionsIndex, {
        id: question.id,
        options,
      });
    });
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }

  get moreOptionsById() {
    return (id: string) => {
      const findArrNewValue = this.newValueArrays.find((filarr: any) => filarr.id === id);

      if (findArrNewValue) {
        return [...findArrNewValue.newValues];
      }

      return [];
    };
  }

  get defaultOptions() {
    return (id: string) => {
      const findArrNewValue = this.filteredOptions.find((filarr: any) => filarr.id === id);

      if (findArrNewValue) {
        return [...findArrNewValue.options];
      }

      return [];
    };
  }
}
